
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buyangle/[slug]",
      function () {
        return require("private-next-pages/buyangle/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buyangle/[slug]"])
      });
    }
  